/**
 * @generated SignedSource<<efd28e46ad83e5a5ca785440e989c9ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type finishSourceMutation$variables = {
  finished: boolean;
  id: string;
};
export type finishSourceMutation$data = {
  readonly finishSource: {
    readonly finished: number | null;
    readonly id: string;
  } | null;
};
export type finishSourceMutation = {
  response: finishSourceMutation$data;
  variables: finishSourceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "finished"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "finished",
        "variableName": "finished"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Rating",
    "kind": "LinkedField",
    "name": "finishSource",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finished",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "finishSourceMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "finishSourceMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1d8d79218083f86c6dd9e6ebd260508e",
    "id": null,
    "metadata": {},
    "name": "finishSourceMutation",
    "operationKind": "mutation",
    "text": "mutation finishSourceMutation(\n  $id: ID!\n  $finished: Boolean!\n) {\n  finishSource(finished: $finished, id: $id) {\n    id\n    finished\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7301954bbe21d1d1dfabfa344f0861e";

export default node;
